import { createEntityAdapter } from '@ngrx/entity';
import { Contact } from '../models/contact.model';

export const externalContactAdapter = createEntityAdapter<Contact>({
  selectId: contact => contact.id
});
